import { DrawerProps } from 'components/Drawer/Root'
import { ImageMenuProvider, Provider } from '../ImageMenuModal/ImageMenuContext'
import { Drawer } from 'components/Drawer'
import { MediaPicker } from 'components/MobileMediaPicker/MediaPicker'
import { getMimeTypesForMediaTypes } from 'components/Wizards/MobileWizards/MobileWizard/components/StartWithMedia/utils'
import { Heading } from 'blaze-ui/Heading/Heading'
import { IMediaFile } from 'components/Design/UploadsTab/Types'
import { ImageMenuProps } from '../Types'

interface ImageMenuDrawerProps extends ImageMenuProps, DrawerProps {}

export const ImageMenuDrawer = (props: ImageMenuDrawerProps) => {
  const { onUse, maxCount, hiddenProviders, onUploadProgress, onUploadStart, onUploadEnd, ...drawerProps } = props
  const accept = getMimeTypesForMediaTypes(['image'])

  const handleSelect = (file: IMediaFile, removeBackground: boolean, provider?: Provider) => {
    if (!provider) {
      return
    }

    onUse([
      {
        ...file,
        provider,
        url: file.source_url,
      },
    ])
  }

  return (
    <ImageMenuProvider
      onUse={onUse}
      uploadMedia={false}
      maxCount={maxCount}
      hiddenProviders={hiddenProviders}
      onUploadProgress={onUploadProgress}
      onUploadStart={onUploadStart}
      onUploadEnd={onUploadEnd}
    >
      <Drawer.Root {...drawerProps}>
        <Drawer.Portal>
          <Drawer.Content fullHeight>
            <Drawer.InnerContent isSnappedTop>
              <Drawer.Top>
                <div />
                <Drawer.Title asChild>
                  <Heading level={5}>Insert Images & Videos</Heading>
                </Drawer.Title>
                <Drawer.Close position="right" />
              </Drawer.Top>
              <Drawer.Container padding="0">
                <MediaPicker onSelect={handleSelect} accept={accept} skipBackgroundRemoval />
              </Drawer.Container>
            </Drawer.InnerContent>
          </Drawer.Content>
          <Drawer.Overlay />
        </Drawer.Portal>
      </Drawer.Root>
    </ImageMenuProvider>
  )
}
